import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { FiEdit, FiTrash2, FiPlus, FiSearch } from 'react-icons/fi';
import Swal from 'sweetalert2';
import { useAuth } from '../contexts/AuthContext';
import ConditionalButton from '../components/common/ConditionalButton';
import ConditionalActions from '../components/common/ConditionalActions';

const ProfQualifPage = () => {
 // const { user } = useAuth();
  const [qualifs, setQualifs] = useState([]);
  const [niveaux, setNiveaux] = useState([]);
  const [professeurs, setProfesseurs] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ qualification_id: '', professeur_id: '', annee_obtention: '', etablissement: '' });
  const [searchTerm, setSearchTerm] = useState('');
  const [filtered, setFiltered] = useState([]);

  const fetchAll = async () => {
    const [qRes, nRes, pRes] = await Promise.all([
      api.get('/prof-qualif'),
      api.get('/niveau-qualif-prof'),
      api.get('/professeurs'),
    ]);
    setQualifs(qRes.data.data || []);
    setNiveaux(nRes.data.data || []);
    setProfesseurs(pRes.data.data || []);
  };

  useEffect(() => { fetchAll(); }, []);

  useEffect(() => {
    setFiltered(
      qualifs.filter(q => {
        const prof = professeurs.find(p => p.id === q.professeur_id) || {};
        const niveau = niveaux.find(n => n.id === q.qualification_id) || {};
        const term = searchTerm.toLowerCase();
        return (
          (prof.nom || '').toLowerCase().includes(term) ||
          (prof.prenom || '').toLowerCase().includes(term) ||
          (niveau.niveau || '').toLowerCase().includes(term) ||
          (q.annee_obtention || '').toLowerCase().includes(term) ||
          (q.etablissement || '').toLowerCase().includes(term)
        );
      })
    );
  }, [searchTerm, qualifs, professeurs, niveaux]);

  const handleEdit = (qualif) => {
    setEditing(qualif);
    setForm({
      qualification_id: qualif.qualification_id || '',
      professeur_id: qualif.professeur_id || '',
      annee_obtention: qualif.annee_obtention || '',
      etablissement: qualif.etablissement || ''
    });
    setModalOpen(true);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Supprimer cette qualification ?',
      text: 'Cette action est irréversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Oui, supprimer',
      cancelButtonText: 'Annuler',
    });
    if (result.isConfirmed) {
      await api.delete(`/prof-qualif/${id}`);
      fetchAll();
      Swal.fire('Supprimé !', 'La qualification a été supprimée.', 'success');
    }
  };

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    if (editing) {
      await api.put(`/prof-qualif/${editing.id}`, form);
    } else {
      await api.post('/prof-qualif', form);
    }
    setModalOpen(false);
    setEditing(null);
    setForm({ qualification_id: '', professeur_id: '', annee_obtention: '', etablissement: '' });
    fetchAll();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold">Gestion des qualifications des professeurs</h1>
        <ConditionalButton
          entity="prof_qualif"
          permission="create"
          className="px-3 py-2 bg-primary-600 text-white rounded hover:bg-primary-700 flex items-center"
          onClick={() => { setEditing(null); setForm({ qualification_id: '', professeur_id: '', annee_obtention: '', etablissement: '' }); setModalOpen(true); }}
          title="Ajouter une qualification"
        >
          <FiPlus />
        </ConditionalButton>
      </div>
      {/* Search Bar */}
      <div className="bg-white p-4 rounded-lg shadow mb-6">
        <div className="relative">
          <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Rechercher une qualification..."
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      <div className="overflow-x-auto rounded shadow">
        <table className="min-w-full divide-y divide-gray-200 bg-white">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-bold uppercase">Professeur</th>
              <th className="px-4 py-2 text-left text-xs font-bold uppercase">Niveau</th>
              <th className="px-4 py-2 text-left text-xs font-bold uppercase">Année</th>
              <th className="px-4 py-2 text-left text-xs font-bold uppercase">Établissement</th>
              <th className="px-4 py-2 text-right text-xs font-bold uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {filtered.map((qualif) => {
              const prof = professeurs.find(p => p.id === qualif.professeur_id) || {};
              const niveau = niveaux.find(n => n.id === qualif.qualification_id) || {};
              return (
                <tr key={qualif.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 whitespace-nowrap">{prof.nom} {prof.prenom}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{niveau.niveau}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{qualif.annee_obtention}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{qualif.etablissement}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <ConditionalActions
                      entity="prof_qualif"
                      onEdit={() => handleEdit(qualif)}
                      onDelete={() => handleDelete(qualif.id)}
                      editIcon={FiEdit}
                      deleteIcon={FiTrash2}
                      className="flex space-x-2"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
          <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-lg">
            <h2 className="text-lg font-semibold mb-4">{editing ? 'Modifier' : 'Ajouter'} une qualification</h2>
            <form onSubmit={handleModalSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Professeur</label>
                <select value={form.professeur_id} onChange={e => setForm({ ...form, professeur_id: e.target.value })} className="w-full border rounded px-3 py-2" required>
                  <option value="">-- Sélectionner --</option>
                  {professeurs.map(p => (
                    <option key={p.id} value={p.id}>{p.nom} {p.prenom}</option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Niveau</label>
                <select value={form.qualification_id} onChange={e => setForm({ ...form, qualification_id: e.target.value })} className="w-full border rounded px-3 py-2" required>
                  <option value="">-- Sélectionner --</option>
                  {niveaux.map(n => (
                    <option key={n.id} value={n.id}>{n.niveau}</option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Année d'obtention</label>
                <input type="text" value={form.annee_obtention} onChange={e => setForm({ ...form, annee_obtention: e.target.value })} className="w-full border rounded px-3 py-2" maxLength={4} />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Établissement</label>
                <input type="text" value={form.etablissement} onChange={e => setForm({ ...form, etablissement: e.target.value })} className="w-full border rounded px-3 py-2" />
              </div>
              <div className="flex justify-end gap-2 mt-6">
                <button type="button" onClick={() => setModalOpen(false)} className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300">Annuler</button>
                <ConditionalButton
                  entity="prof_qualif"
                  permission={editing ? "update" : "create"}
                  type="submit"
                  className="px-4 py-2 rounded bg-primary-600 text-white hover:bg-primary-700"
                >
                  Enregistrer
                </ConditionalButton>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfQualifPage;
